module.exports = {"652826100":"焉耆镇","652826101":"七个星镇","652826102":"永宁镇","652826103":"四十里城子镇","652826200":"北大渠乡","652826201":"五号渠乡","652826203":"查汗采开乡","652826204":"包尔海乡","652826400":"王家庄牧场","652826401":"苏海良种场","652826501":"兵团二十七团"}


//////////////////
// WEBPACK FOOTER
// ./src/town/652826.json
// module id = 2871
// module chunks = 0